import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import PropTypes from 'prop-types';
import ProduitsAssignes from 'pages/gant/components/mediasPages/ProduitsAssignes';
import React, { Fragment } from 'react';
import { useGetAnnonceProdQuery } from '../../../redux/api/cache';

export default function MessageProduits(props) {
  const { data, isLoading } = useGetAnnonceProdQuery(props.data.ann_seq);

  return (
    <Fragment>
      {isLoading && <LoadingCard title="Chargement produits..." />}
      {!isLoading && data !== undefined && (
        <Card
          expanded={data?.data?.length > 0 || isLoading}
          key={'card produits'}>
          <Header title={`Produits assignés`}></Header>
          <Body>
            <ProduitsAssignes global={false} data={data} create={true} infos={props.data} annonce={true} />
          </Body>
        </Card>
      )}
    </Fragment>
  );
}

MessageProduits.propTypes = {
  data: PropTypes.shape({
    rowData: PropTypes.shape({
      ann_seq: PropTypes.any
    }),
  }),
};
